import { render, staticRenderFns } from "./IndexLayout.vue?vue&type=template&id=1cfd5976&scoped=true"
import script from "./IndexLayout.vue?vue&type=script&lang=js"
export * from "./IndexLayout.vue?vue&type=script&lang=js"
import style0 from "./IndexLayout.vue?vue&type=style&index=0&id=1cfd5976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cfd5976",
  null
  
)

export default component.exports